import React from "react";
import LegalPageLayout, { Section, SectionTitle, Paragraph } from "components/legal/LegalPageLayout.js";

export default () => {
  return (
    <LegalPageLayout
      productName="VIPSO"
      productUrl="/products/vipso"
      title="Terms of Service"
      lastUpdated="July 10, 2026"
    >
      <Section>
        <Paragraph>
          These Terms of Service govern your use of the VIPSO mobile application operated by <strong>Spurnest Techlabs</strong> ("we", "us", "our"), headquartered in Gandhinagar, Gujarat, India.
        </Paragraph>
        <Paragraph>By using VIPSO, you agree to these Terms. If you disagree, do not use the Service.</Paragraph>
      </Section>

      <Section>
        <SectionTitle>Use of the Service</SectionTitle>
        <Paragraph>
          VIPSO is a business application for accounting, inventory, and purchase order management. You agree to use it only for lawful business purposes and in compliance with applicable laws.
        </Paragraph>
        <Paragraph>You are responsible for maintaining the confidentiality of your account and all activity under it.</Paragraph>
      </Section>

      <Section>
        <SectionTitle>Subscriptions</SectionTitle>
        <Paragraph>
          VIPSO may offer subscription plans processed through Google Play. Payment, renewal, and cancellation are governed by Google Play's terms. We do not store your payment card details.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Intellectual Property</SectionTitle>
        <Paragraph>
          VIPSO and its original content, features, and functionality are owned by Spurnest Techlabs and protected by applicable copyright and trademark laws.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Limitation of Liability</SectionTitle>
        <Paragraph>
          To the maximum extent permitted by law, Spurnest Techlabs shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of VIPSO, including loss of data or business profits.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Termination</SectionTitle>
        <Paragraph>
          We may suspend or terminate your access to VIPSO at any time for violation of these Terms, without prior notice.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Governing Law</SectionTitle>
        <Paragraph>
          These Terms are governed by the laws of India. Disputes shall be subject to the exclusive jurisdiction of courts in Gandhinagar, Gujarat.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Contact</SectionTitle>
        <Paragraph>
          <a href="mailto:info@spurnest.com" tw="text-primary-500 font-semibold">info@spurnest.com</a>
        </Paragraph>
      </Section>
    </LegalPageLayout>
  );
};
